import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

if (process.env.NODE_ENV === "production") {
    fetch("/settings", {
        headers: {
            "Content-Type": "application/json",
        },
        method: "get",
    }
    ).then(res => {
        return res.json()
    }).then(data => {
        root.render(
            <App
                aiName={data.aiName}
                apiBaseUrl={data.apiBaseUrl}
                apimKey={data.apimKey}
                welcomeMessage={data.welcomeMessage}
                aiAskMessage={data.aiAskMessage}
            />
        );
    }).catch(err => {
        console.log(err)
    })
} else {
    root.render(
        <App
            aiName="Anna"
            apimKey="test"
            apiBaseUrl="6454a0afda81bb8bc46ee24aaff3ac3e8ebb22760e95b7fa0d7f9028439c2478"
            welcomeMessage="欢迎访问CTI华测！国家CNAS&CMA检测机构及欧盟NB指定认证机构，行业首家上市公司，股票代码：300012。请您提供【联系电话】+【需求】，我们安排【工程师】联系您哦~"
            aiAskMessage="我是AI客服Anna，您是要检测什么产品和项目呢？"
        />
    );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
